<h1 *ngIf="messageView.h1" class="header1">{{ messageView.h1 | translate}}</h1>
<h2 *ngIf="messageView.h2">{{ messageView.h2 | translate }}</h2>
<div *ngIf="messageView.showText" class="message-text" [innerHTML]="messageView.text"></div>
